import React from "react";
import PropTypes from "prop-types";

import "./Checkbox.css";

/**
 * @param {function} onChange ( checked: boolean )
 * @param {boolean} checked
 */
export default class Checkbox extends React.Component {
  
  static propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    cssModifier: PropTypes.string
  }
  
  static defaultProps = {
    checked: false,
    disabled: false
  }
  
  onClick = () => {
    const { checked, disabled, onChange } = this.props;
    if (!disabled && onChange !== undefined) {
      this.props.onChange(!checked);
    }
  }
  
  render() {
    
    const { checked, disabled, cssModifier } = this.props;
    
    const classNames = [ "checkbox" ];
    if (checked) {
      classNames.push("checkbox--checked");
    } else {
      classNames.push("checkbox--unchecked");
    }
    if (disabled) {
      classNames.push("checkbox--disabled");
    }
    
    if (cssModifier) {
      classNames.push(`checkbox--${cssModifier}`);
    }
    
    return (
      <span className={classNames.join(" ")} onClick={this.onClick}>
        <span className="checkbox__mark" />
      </span>
    );
    
  }
  
}



// WEBPACK FOOTER //
// ./src/components/Checkbox.js